'use strict'

var create = require('./util/create')

module.exports = create({
  space: 'xml',
  transform: xmlTransform,
  properties: {
    xmlLang: null,
    xmlBase: null,
    xmlSpace: null
  }
})

function xmlTransform(_, prop) {
  return 'xml:' + prop.slice(3).toLowerCase()
}



//////////////////
// WEBPACK FOOTER
// ./~/rehype-react/~/property-information/lib/xml.js
// module id = 428
// module chunks = 35783957827783 241767136424496